//@ts-check
function stripObject(obj, propsToRemove) {
    if (!Array.isArray(propsToRemove)) return
    for (const propName of propsToRemove) {
        if (typeof propName !== 'string') continue
        delete obj[propName]
    }
}

export function stripClub(club) {
    const propsToStrip = ['@id', '@type', 'averageOverallScore', 'latestStadiumAnalysis', 'pitches']
    stripObject(club, propsToStrip)
}

export function stripTestCategory(testCategory) {
    testCategory.templateType = testCategory.pitchTemplate.templateType
    testCategory.grid = testCategory.pitchTemplate.grid
    const propsToStrip = [
        '@context', '@id', '@type', 'displayInClubOverview',
        'hasPhysicalAssessments', 'hasPitchAssessments', 'parameters', 'pitchTemplate', 'unit'
    ]
    stripObject(testCategory, propsToStrip)
}

export function stripAnalyses(analysesArray, options = {stripIndexes: true}) {
    const analysisPropsToStrip = [
        '@id', '@type', 'assessment', 'groupScores', 'rawCertified', 'score', 'summary', 'testGroups', 'tester', 'indexResults',
    ]

    if (options.stripIndexes) {
        analysisPropsToStrip.push( 'filteredIndexResults')
    }

    const testPropsToStrip = [
        '@id', '@type', 'advices', 'advicesGrounds', 'advicesPerformance', 'comment', 'completed', 'parameterResults',
        'physicalImpact', 'pitchImpact', 'rawCertified', 'score', 'values', 'analysisDate'
    ]
    const zoneResultPropsToStrip = [
        '@id', '@type', 'id', 'rating', 'weight', 'posX', 'posY', 'measurement'
    ]

    analysesArray.forEach(anal => {
        anal.pitch = anal.pitch.id
        stripObject(anal, analysisPropsToStrip)
        anal.tests?.forEach(test => {
            test.testCategory = test.testCategory.id
            stripObject(test, testPropsToStrip)
            //filter out empty or 'ignored' zones
            test.zoneResults = test.zoneResults.filter(zoneResult => (zoneResult.measurement !== null) && (zoneResult.weight > 0))
            test.zoneResults?.forEach(zR => {
                zR.x = zR.posX
                zR.y = zR.posY
                zR.val = zR.measurement
                stripObject(zR, zoneResultPropsToStrip)
            })
        })
        //remove tests left with no zones after cleaning
        anal.tests = anal.tests?.filter(test => test.zoneResults.length > 0)
    })
}
